export default __webpack_public_path__ + "static/media/consult-a-doc.700d3de4.gif";